import {gsap} from "../LibrariesImport";

export default class AppearOnScroll {
	static init() {
		const items = document.querySelectorAll("[data-aos]");

		items.forEach((item) => {
			const delay = item.dataset.aosDelay ?? 0; // Utilisez l'attribut HTML `data-aos-delay`

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: item,
					start: "top 90%"
				},
			});

			// Ajoutez une animation vide avec un délai pour appliquer la classe "appeared"
			timeline.to(item, { delay: parseFloat(delay), onComplete: () => item.classList.add("appeared") });
		});
	}
}
